module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#photostory",
      toString: function () {
        return this.url;
      }
    }